import { render, staticRenderFns } from "./publishTreeNode.vue?vue&type=template&id=ba46f6c2"
import script from "./publishTreeNode.vue?vue&type=script&lang=js"
export * from "./publishTreeNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports